export default __webpack_public_path__ + "static/media/Training.b2074e25.jpg";